import { Grid, Typography, TypographyProps, Skeleton, GridProps } from '@mui/material';
import { ReactNode } from 'react';

export interface LabeledDataStackProps {
  loading?: boolean;
  size?: GridProps['size'];
  label?: ReactNode | null;
  labelProps?: Partial<TypographyProps>;
  body?: ReactNode | null;
  bodyProps?: Partial<TypographyProps>;
}

export const LabeledDataStack = ({ loading, size = 12, label, labelProps, bodyProps, body }: LabeledDataStackProps) => {
  return (
    <>
      <Grid size={size}>
        <Typography variant="body2" color="textSecondary" {...labelProps}>
          {label || null}
        </Typography>
        <Typography variant="body2" color="textPrimary" {...bodyProps}>
          {loading ? <Skeleton /> : body || null}
        </Typography>
      </Grid>
    </>
  );
};
